import { useClientContext } from "@hooks/index";
import { useMemo } from "react";
import { getGantt, getManagement, getStatusByDate } from "./index";

export const useTimeline = () => {
  const customFetch = useClientContext();

  return useMemo(
    () => ({
      getStatusByDate: getStatusByDate(customFetch),
      getManagement: getManagement(customFetch),
      getGantt: getGantt(customFetch),
    }),
    [customFetch]
  );
};
